import { CacheScenario, CacheTime, MethodType } from 'app/models/api/cache';
import { API_ENDPOINT } from './utils.service';

export const legendServiceCache: () => CacheScenario[] = (): CacheScenario[] => [
  {
    description: 'method getPalette, caching color palette',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/legend`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      {
        url: `${API_ENDPOINT}/legend/all`,
        method: MethodType.PUT,
      },
    ],
  },
];
